import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import { catchError,map } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable, of, throwError } from 'rxjs';
import * as globalConstant from './../global_constant';


@Injectable({
  providedIn: 'root'
})
export class CoupanService {
  apiDomain				           =	globalConstant.DOMAIN;
  siteRequestFrom				   =	globalConstant.SITE_REQUEST_FROM;
  createGuestUserCoupan            =    globalConstant.GUEST_USER_COUPAN;
  checkCoupan                      =    globalConstant.CHECK_COUPAN;
  
  constructor(public http: HttpClient) {  

  }
  
   saveVisitorData(data){
    const httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'requestFrom':this.siteRequestFrom
        })
    };	
    return this.http.post<any>(this.apiDomain+this.createGuestUserCoupan, data ,httpOptions).pipe(map(res=>{
        return res;
    }),
    catchError(err => {
        return err.error;
    }));
}

checkCoupanData(data){
    const httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'requestFrom':this.siteRequestFrom
        })
    };	
    return this.http.post<any>(this.apiDomain+this.checkCoupan, data ,httpOptions).pipe(map(res=>{
        return res;
    }),
    catchError(err => {
        return err.error;
    }));
}
}